import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subtitleCellFormater',
  standalone: false,
})
export class SubtitleCellFormaterPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const { subtitleCellFormater } = args;
    return subtitleCellFormater ? subtitleCellFormater(value) : value;
  }
}
